import { HTML_FONT_SIZE_IN_PX, ROOT_FONT_SIZE_IN_PX } from '@/@mui/constants';

export const pxToRem = (value: number): string => {
  const coef = ROOT_FONT_SIZE_IN_PX / 14;

  if (isNaN(value)) {
    throw new Error('[pxToRem] only numbers');
  }

  return `${(value / HTML_FONT_SIZE_IN_PX) * coef}rem`;
};
